
import { Base } from '../base-component';

import './banner-mid-page-white-item.component.scss';

export class BannerMidPageWhiteItem extends Base {

	constructor(element: Element){
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/banner-mid-page-white-item/banner-mid-page-white-item.component.ts